import React from 'react';
import "./icon.scss";

export const Logo = ({ size }: { size: 'large' | 'medium' | 'small' | 'xsmall' }) => {
    return <div className={`logo-icon ${size}`}>
        
    </div>
}